import { useCallback, useState } from 'react';
import { getDefaultCardSelection, isProductHasVariants } from '../components/ProductCardQuantity';
import { buildCartProductFromSelection } from '../utils/cartProductHelpers';

/**
 * Shared quantity/weight selection state for product cards.
 */
export function useProductCardCart(getBasePrice) {
    const [selections, setSelections] = useState({});
    const [weightHintId, setWeightHintId] = useState(null);

    const getSelection = useCallback((product) => {
        return selections[product.id] || getDefaultCardSelection(isProductHasVariants(product));
    }, [selections]);

    const updateSelection = useCallback((product, next) => {
        setSelections((prev) => ({ ...prev, [product.id]: next }));
    }, []);

    const prepareCartItem = useCallback((product) => {
        const basePrice = getBasePrice(product);
        return buildCartProductFromSelection(product, basePrice, getSelection(product));
    }, [getBasePrice, getSelection]);

    const showWeightHint = useCallback((productId) => {
        setWeightHintId(productId);
        setTimeout(() => setWeightHintId(null), 2000);
    }, []);

    const getDisplayPrice = useCallback((product) => {
        const base = getBasePrice(product);
        const sel = getSelection(product);
        if (isProductHasVariants(product) && sel.weightValue) {
            return base * sel.weightValue;
        }
        return base;
    }, [getBasePrice, getSelection]);

    const getWeightText = useCallback((product) => {
        if (isProductHasVariants(product)) {
            return getSelection(product).weightLabel || null;
        }
        return product.weight || null;
    }, [getSelection]);

    return {
        getSelection,
        updateSelection,
        prepareCartItem,
        weightHintId,
        showWeightHint,
        getDisplayPrice,
        getWeightText,
    };
}
